<template>
    <div class="container-dynamic-delete">
        <p>Selecione um <strong>usuário de Perfil Dinâmico</strong> para receber os dados do usuário(a) <strong>{{user.name}}</strong> </p>
        <p>O usuário selecionado passará a fazer parte das filas de distribuição de leads e oferta ativa, caso o usuário(a) <strong>{{user.name}}</strong> faça parte de alguma dessas filas.</p>
        <ui-select-v2
            v-model="selectNewTean"
            label="Perfis Dinâmicos:"
            item-label="label"
            return-value="label"
            :data="dinamicGroup"
            :loading="loadingDinamic"
            @input='leave'
        />
        <ui-select-v2
            v-if="loadDinamic"
            v-model="selectNewDinamic"
            :label="''"
            item-label="label"
            return-value="value"
            :data="loadDinamic"
            @input='setLeave'
        />
        <div v-if="load" class="load">
            <ui-load-indicator
                bg-color="#e7e9f4"
                color="#69D296"
                :h="30"
                :stroke="5" />
        </div>
        <div v-if="dinamicNotFound" class="not-found">
            <p> <i aria-hidden="true" class="fad fa-user-times"/> Não encontramos nenhum Usuário</p>
        </div>
    </div>
</template>

<script>
    import { uiLoadIndicator } from '@/components/ui';
import { uiSelectV2 } from '@/components/ui/form';
import { user } from '@/services/axios';
    export default {
        name: 'ui-dinamic-delete',
        components: {
            uiSelectV2,
            uiLoadIndicator
        },
        props: {
            otherTeans: {
                type: [Array, Object],
                default: () => {}
            },
            user: {
                type: [String, Object],
                default: () => {}
            }
        },
        data() {
            return {
                selectNewTean: '',
                loadDinamic: null,
                selectNewDinamic: '',
                load: false,
                dinamicNotFound: false,
                dinamicGroup: [],
                loadingDinamic: false
            }
        },
        mounted() {
            this.loadGroup()
        },
        methods: {
            loadGroup() {
                this.loadingDinamic = true
                user.getAll(`groups/dynamics`).then(res => {
                    for(const key in res.data) {
                        this.dinamicGroup.push({id: res.data[key].id, label: res.data[key].name})
                    }
                    this.loadingDinamic = false
                })
            },
            leave(value) {
                this.load = true
                this.loadDinamic = null
                user.getAll(`search?group=${value}&por_page=100`).then(res => {
                    if(res.data.length == 0) {
                        this.dinamicNotFound = true
                        return this.load = false
                    }
                this.loadDinamic = res.data.data.map(val => {
                    if (user.name != val.first_name) {
                            return {value: val.id, label: val.first_name, id: val.id}
                    }
                    })
                    this.load= false
                }).catch (() => {
                    this.load = false
                    this.dinamicNotFound = true
                })
            },
            setLeave(value) {
                if(value.length == 0) {
                    return this.$emit('desactive', 'remove', true)
                };
                this.$emit('desactive', 'remove', false)
                this.$emit('input', value, null, null)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>